import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ChannelActionCreators from '../../actions/ChannelActionCreators';
import FileActionCreators from '../../actions/FileActionCreators';
import PatientActionCreators from '../../actions/PatientActionCreators';
import ChannelDetailContent from '../../components/messaging/ChannelDetailContent';

const ChannelDetailContentContainer = ({
  actions: {
    fetchPatientDetail,
    fetchPrevChannelMessages,
    getPhotoDownloadURL,
  },
  channelMembers,
  className,
  currentChannelId,
  currentUserId,
  messages,
  medicalRecordDetail,
  medicalRecords,
  resizeTrigger,
}) => {
  const handleFetchPrevChannelMessages = () => {
    if (!_.isEmpty(messages)) {
      // NOTE: debug usage, default fetch amount = 30.
      const limit = 5;

      // NOTE: why -1, check out the comment in ChannelAPIConnectors.js.
      fetchPrevChannelMessages(currentChannelId, messages[0].seq - 1, limit);
    }
  };

  return (
    <ChannelDetailContent
      channelMembers={channelMembers}
      className={className}
      currentChannelId={currentChannelId}
      currentUserId={currentUserId}
      messages={messages}
      membersByUserId={channelMembers}
      onFetchPrevChannelMessages={handleFetchPrevChannelMessages}
      onGetPhotoDownloadURL={getPhotoDownloadURL}
      medicalRecordDetail={medicalRecordDetail}
      medicalRecords={medicalRecords}
      resizeTrigger={resizeTrigger}
      onClickMedicalRecordTag={fetchPatientDetail}
    />
  );
};

const mapStateToProps = (state) => {
  const { currentChannelId, channels } = state.channel;
  const idx = _.findIndex(channels, { id: currentChannelId });
  return {
    currentChannelId,
    currentChannel: channels[idx],
    currentUserId: parseInt(state.user.userId, 10),
    messages: state.channel.msgsInChannel[currentChannelId],
    channelMembers: state.channel.membersInChannel[currentChannelId],
  };
};

const mapDispatchToProps = (dispatch) => {
  const allActions = {
    ...ChannelActionCreators,
    ...FileActionCreators,
    ...PatientActionCreators,
  };

  return {
    actions: bindActionCreators(allActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChannelDetailContentContainer);



// WEBPACK FOOTER //
// ./src/containers/messaging/ChannelContentContainer.js